module.exports = "<div>\n    <div class=\"inset\">\n        <div layout=\"row\">\n            <parameter-list flex=\"20\"></parameter-list>\n            <div ui-view=\"content\" flex=\"70\" flex-offset=\"5\">\n                <single-parameter></single-parameter>\n            </div>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/evaluation/pages/stepMiniPedagogicalApproach/stepMiniPedagogicalApproachView.html
// module id = 505
// module chunks = 0